import gql from 'graphql-tag'

function buildWhereClauses ({ includeDealFilter, demoOnly, publishedOnly }) {
  const clauses = []

  if (includeDealFilter) {
    clauses.push(`deal: { id: { equals: $auditDealId } }`)
  }
  if (typeof demoOnly === 'boolean') {
    clauses.push(`is_demo: { equals: ${demoOnly} }`)
  }
  if (publishedOnly) {
    clauses.push(`isPublished: { equals: true }`)
  }

  return clauses.join(',\n              ')
}

function buildEntityQuery ({
  operationName,
  rootField,
  orderByField,
  selectionSet,
  includeDealFilter = true,
  demoOnly,
  publishedOnly = false
}) {
  const variablesDefinition = includeDealFilter ? '($auditDealId: ID!)' : ''
  const whereClauses = buildWhereClauses({ includeDealFilter, demoOnly, publishedOnly })
  const whereBlock = whereClauses ? `where: {\n              ${whereClauses}\n            },` : ''

  return gql`query ${operationName}${variablesDefinition} {
    ${rootField}(
      ${whereBlock}
      orderBy: [{
        ${orderByField}: asc
      }]
    ) {
      ${selectionSet}
    }
  }`
}

const AUDITS_SELECTION = `
  id
  isPublished
  workDate
  brand
  model
  panelBrand
  panelModel
  powerSource {
    name
  }
  pdfFile {
    url
  }
  observations {
    document(hydrateRelationships: true)
  }
  endSystems {
    outletType {
      id
    }
    radius
    sprinklerType {
      id
      brand
      model
    }
    nozzle {
      size
    }
    observations
    flow
    endPressure
  }
  device {
    id
    name
    isMobile
    locationLatitude
    locationLongitude
  }
  calculatedData {
    totalFlow
    pluviometricUniformity
    irrigationCapacity
    irrigationHoursWithMargin
    totalIrrigationArea
  }
  spans {
    id
    number
    length
    observations
    spanType {
      id
      name
    }
    calculatedData {
      accLarge
      currentFlow
      deviation
      difference
      requiredFlow
      sectorArea
    }
    pipeAmount
    pipe {
      diameter
      perimeter
    }
    tower {
      tyres {
        size {
          name
        }
      }
      motor {
        rpm {
          id
          name
        }
        brand
        model
      }
    }
    outlets {
      observations
      isFlex
      span {
        number
      }
      weight
      number
      flow
      accFlow
      sprinkler {
        sprinklerType {
          id
          brand
          model
        }
        nozzle {
          id
          size
          brand
          color
        }
        pad {
          id
          brand
          model
        }
      }
      regulator {
        id
        pressure {
          name
        }
        regulatorType {
          brand
          model
        }
      }
      type {
        id
        name
      }
    }
  }
`

const FLOW_MEASUREMENTS_SELECTION = `
  id
  isPublished
  workDate
  device {
    id
    name
    locationLatitude
    locationLongitude
  }
  observations {
    document(hydrateRelationships: true)
  }
  pdfFile {
    url
  }
  flowSamples {
    measureDate
    flow
    q
    s
    vel
    eqPressure
    flowMeterImages {
      file {
        url
      }
    }
    pressureImages {
      file {
        url
      }
    }
  }
  eqStatus {
    eqStatusValue {
      name
    }
    speed
    toPumpDistance
    observations
    pressure
    structureImages {
      file {
        url
      }
    }
    frontPanelImages {
      file {
        url
      }
    }
    pressureImages {
      file {
        url
      }
    }
  }
  pumps {
    brand
    model
    type {
      name
    }
    pumpStatus {
      rpm
      pumpPressure
      deviceDistance
      rpmImages {
        file {
          url
        }
      }
      pressureImages {
        file {
          url
        }
      }
      motorImages {
        file {
          url
        }
      }
      description
    }
    pipe {
      diameter
    }
    observations
    coordinates
  }
`

const PLUVIOMETRIC_CHARTS_SELECTION = `
  id
  isPublished
  device {
    id
    name
  }
  file {
    url
  }
  sharingUrl
`

const UNIFORMITIES_SELECTION = `
  id
  isPublished
  workDate
  coefficientOfUniformity
  deviationAgainstConfiguration
  pdfFile {
    url
  }
  device {
    id
    name
  }
`

export function getAuditsListQuery (options = {}) {
  return buildEntityQuery({
    operationName: 'getAudits',
    rootField: 'audits',
    orderByField: 'workDate',
    selectionSet: AUDITS_SELECTION,
    ...options
  })
}

export function getFlowMeasurementsListQuery (options = {}) {
  return buildEntityQuery({
    operationName: 'getFlowMeasurements',
    rootField: 'flowMeasurements',
    orderByField: 'workDate',
    selectionSet: FLOW_MEASUREMENTS_SELECTION,
    ...options
  })
}

export function getPluviometricChartsListQuery (options = {}) {
  return buildEntityQuery({
    operationName: 'getPluviometricCharts',
    rootField: 'pluviometricCharts',
    orderByField: 'id',
    selectionSet: PLUVIOMETRIC_CHARTS_SELECTION,
    ...options
  })
}

export function getUniformitiesListQuery (options = {}) {
  return buildEntityQuery({
    operationName: 'getUniformities',
    rootField: 'uniformities',
    orderByField: 'workDate',
    selectionSet: UNIFORMITIES_SELECTION,
    ...options
  })
}



// WEBPACK FOOTER //
// ./src/lib/auditsQueries.js